export default {
  responsive: true,
  maintainAspectRatio: false,
  legend: { display: false },
  tooltips: { cornerRadius: 0 },
  scales: {
    xAxes: [{
      display: true,
      type: 'time',
      time: {
        displayFormats: {
          day: 'DD MMMM'
        }
      }
    }],
    yAxes: [{
      display: true,
      gridLines: {
        display: true,
        color: 'rgba(0, 0, 0, 0.08)'
      },
      ticks: {
        beginAtZero: true
      }
    }]
  },
  elements: {
    point: {
      radius: 1
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/chart-options/timeBasedLinesBar.js